import { Helmet } from 'react-helmet-async';

export default function SEOHead({ seo }) {
  if (!seo) return null;
  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="keywords" content={seo.keywords} />
      <link rel="canonical" href={seo.canonical} />
      {seo.og && (
        <>
          <meta property="og:title" content={seo.og.title} />
          <meta property="og:description" content={seo.og.description} />
          <meta property="og:type" content={seo.og.type} />
          <meta property="og:url" content={seo.og.url} />
          <meta property="og:image" content={seo.og.image} />
        </>
      )}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.og?.title || seo.title} />
      <meta name="twitter:description" content={seo.og?.description || seo.description} />
    </Helmet>
  );
}
